export default __webpack_public_path__ + "img/1_9-8d0ed075.png";